<template>
  <form @keyup.enter="filter()" @submit.prevent>
    <div class="row pt-3">
      <div class="col-4">
        <text-input
          formGroupClass="flex-grow-1"
          v-model="form.searchText"
          placeholder="Pesquisar por fornecedor ou número da nota..."
        />
      </div>
      <div class="col-6">
        <button
          type="button"
          class="btn btn-sm btn-primary mr-3"
          @click="showFilters = !showFilters"
        >
          <i class="fas fa-filter" /> Mais Filtros
        </button>
        <button type="button" class="btn btn-sm btn-primary" @click="filter()">
          <i class="fas fa-filter" /> Pesquisar
        </button>
      </div>

      <div v-if="buttonPrint == true" class="col text-right mr-4">
        <button type="button" class="btn btn-sm btn-primary" @click="print()">
          <i class="fas fa-print mr-1" /> Imprimir
        </button>
      </div>
    </div>
    <b-collapse v-model="showFilters">
      <div class="row">
        <div class="col-2">
          <date-input
                @input="dateSavedDefault()"
            v-model="form.saved_at_start_input"
            alias="Data de Cadastro Inicial"
          /> 
       </div>
        <div class="col-2">
          <date-input
            @input="dateSavedDefault()"
            v-model="form.saved_at_end_input"
            alias="Data de Cadastro Final"
          />
        </div>

        <div class="col-2">
          <date-input
            @input="dateSavedDefault()"            
            v-model="form.emited_at_start"
            alias="Data de Emissão Inicial"
          />
        </div>
        <div class="col-2">
          <date-input
            @input="dateSavedDefault()"
            v-model="form.emited_at_end"
            alias="Data de Emissão Final"
          />
        </div>

        <div class="col-2">
          <date-input
          @input="dateSavedDefault()"
            v-model="form.entry_at_start"
            alias="Data de Entrada Inicial"
          />  
        </div>
        <div class="col-2">
          <date-input
          @input="dateSavedDefault()"
            v-model="form.entry_at_end"
            alias="Data de Entrada Final"
          />
      </div>

    </div>
      <div class="row">
        <div class="col-2 align-self-center d-flex">
          <b-button id="limpa" 
            @click="clear()"
            class="x-small"
            style="width: auto"
            size="sm"
          >
            <i class="fas fa-times" /> Limpar Filtro
          </b-button>
        </div>
        <div class="col-4 align-self-center d-flex">
          <b-form-checkbox
            switch
            inline
            :value="'d'"
            @change="filter(1)"
            :unchecked-value="''"
            v-model="form.status"
          >
            <small>Rascunho</small>
          </b-form-checkbox>
          <b-form-checkbox
            switch
            inline
            :value="'p'"
            @change="filter(1)"
            :unchecked-value="''"
            v-model="form.status"
          >
            <small>Compras</small>
          </b-form-checkbox>
          <b-form-checkbox
            switch
            inline
            :value="'c'"
            @change="filter(1)"
            :unchecked-value="''"
            v-model="form.status"
          >
            <small>Canceladas</small>
          </b-form-checkbox>
        </div>
        <div class="col-3">
          <number-input
            v-model="form.max_value"
            alias="Valor da Nota Maior Que"
          />
        </div>
        <div class="col-3">
          <number-input
            v-model="form.min_value"
            alias="Valor da Nota Menor Que"
          />
        </div>
      </div>
    </b-collapse>
  </form>
</template>

<script>
import moment from "moment";

export default {
  props: {
    buttonPrint: {},
  },
  data() {
    return {
      showFilters: false,
      form: {
        status: ["d", "p", "c"],
        saved_at_start: null,
        saved_at_end: null,
        emited_at_start: null,
        emited_at_end: null,
        entry_at_start: null,
        entry_at_end: null,
        max_value: null,
        min_value: null,
        searchText: null,
        saved_at_start_input: null,
        saved_at_end_input: null,
        saved_at_start_report: null,
        saved_at_end_report: null,
      },
    };
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.$emit("input", this.form);
      },
    },
  },
  methods: {
    filter() {
      this.$emit("filter");
    },
    clear() {
      this.form.searchText = null;
      this.form.status = ["d", "p", "c"];
      this.form.saved_at_start = null;
      this.form.saved_at_end = null;
      this.form.emited_at_start = null;
      this.form.emited_at_end = null;
      this.form.entry_at_start = null;
      this.form.entry_at_end = null;
      this.form.max_value = 0;
      this.form.min_value = 0;
      this.form.saved_at_start_input = null;
      this.form.saved_at_end_input   = null;
      this.form.saved_at_start_report  =  moment().subtract(30, "days").format("YYYY-MM-DD");
      this.form.saved_at_end_report    =  moment().format("YYYY-MM-DD");
      this.$emit("filter");
      
    },

    print() {
      this.$emit("print");
    },
    dateSavedDefault(){
    this.form.saved_at_start        = this.form.saved_at_start_input;//null; 
    this.form.saved_at_end          = this.form.saved_at_end_input;//null;  
    this.form.saved_at_start_report = this.form.saved_at_start_input;//null; 
    this.form.saved_at_end_report   = this.form.saved_at_end_input;//null;   
    }
 }
}
</script>

<style>
</style>